import { IBaseModel } from "../BaseModel";

export enum UserStatus {
  Archived,
  Disabled,
  Enabled,
  Invited
}

export enum UserMembershipStatus {
  Disabled,
  Enabled,
}

interface IUserClaimRecord {
  type: string;
  value: string;
}

/** A user's membership of one customer. */
export interface IUserMembership {
  customerId: string;
  customerName: string | null;
  isDefault: boolean;
  status: UserMembershipStatus;
  lastLogin: string | null;
}

export interface IUser extends IBaseModel {
  forename: string;
  surname: string;
  username: string;
  email: string | null;
  /** The user's default customer; see `memberships` for every customer they belong to. */
  customerId: string;
  isDefaultCustomer: boolean;
  membershipStatus: UserMembershipStatus | null;
  memberships: IUserMembership[];
  membershipCount: number;
  status: UserStatus;
  version: number;
  ssoLogin: boolean;
  hasPin: boolean;
  lastLogin: string | null;
  /** Role claims for the customer the user was loaded under. */
  userClaims: IUserClaimRecord[];
}

/** Result of the cross-customer user search used to add an existing user to a customer. */
export interface IUserSearchResult {
  id: string;
  forename: string;
  surname: string;
  username: string;
  email: string | null;
  status: UserStatus;
  ssoLogin: boolean;
  memberships: IUserMembership[];
}

export interface IAddUserMembershipRequest {
  userId?: string;
  username?: string;
  roleId?: string;
  claims?: Record<string, string>;
  makeDefault?: boolean;
}
